module.exports = __webpack_public_path__ + "img/us-4.2ee18cde.png";